import { render, staticRenderFns } from "./MerchantPaymentRequest.vue?vue&type=template&id=4c1eb755&scoped=true"
import script from "./MerchantPaymentRequest.vue?vue&type=script&lang=js"
export * from "./MerchantPaymentRequest.vue?vue&type=script&lang=js"
import style0 from "./MerchantPaymentRequest.vue?vue&type=style&index=0&id=4c1eb755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1eb755",
  null
  
)

export default component.exports